import React, { useContext, useEffect } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import StoreContext from '../react-core-lib/components/app/store-context';

const LogoutRoute = () => {
    const appStateStore = useContext(StoreContext);
    const navigate = useNavigate();

    useEffect(() => {
        const logout = async () => {
            await appStateStore.authStore.logout();
            await appStateStore.clearUserStores();
            localStorage.clear();
            navigate('/', { replace: true });
        };

        logout();
    }, [appStateStore, navigate]);

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: '#F0F0FC',
            }}
        >
            <CircularProgress />
        </Box>
    );
};

export default LogoutRoute;
